export default __webpack_public_path__ + "static/media/Mark-3-HUD-Altimeter.5d6d4add.jpg";